import { createFileRoute, Link } from "@tanstack/react-router";
import { SiteLayout } from "@/components/site/Layout";
import { DoctorsAccordion } from "@/components/sections/DoctorsAccordion";
import { Appointment } from "@/components/sections/Appointment";
import { ChevronRight } from "lucide-react";
import teamHero from "@/assets/team-hero.jpg";
import { loadDashboardSeo, mergeSeoHead } from "@/lib/dashboard-seo";

export const Route = createFileRoute("/about_/the-team")({
  loader: () => loadDashboardSeo("/about/the-team"),
  head: ({ loaderData }) => mergeSeoHead(loaderData, ({
    meta: [
      { title: "The Team, Bayly Dental Clinic" },
      {
        name: "description",
        content:
          "Meet the dentists and clinical Team at Bayly Dental Clinic in Pickering, friendly faces dedicated to your comfort and care.",
      },
      { property: "og:title", content: "The Team, Bayly Dental Clinic" },
      {
        property: "og:description",
        content: "Meet the friendly dentists behind every healthy smile at Bayly Dental.",
      },
          { property: "og:url", content: "https://baylydentalclinic.com/about/the-team" },
],
    links: [
      { rel: "canonical", href: "https://baylydentalclinic.com/about/the-team" },
    ],
  })),
  component: TheTeamPage,
});

function TheTeamPage() {
  return (
    <SiteLayout>
      <section className="relative overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${teamHero})` }}
        />
        <div className="absolute inset-0 bg-black/50" />
        <div className="relative z-10 container-1120 py-16 md:py-24 text-center">
          <nav aria-label="breadcrumb" className="flex justify-center">
            <ol className="eyebrow flex items-center gap-1.5">
              <li>
                <Link to="/" className="hover:underline">Home</Link>
              </li>
              <ChevronRight className="h-3 w-3" aria-hidden="true" />
              <li aria-current="page">The Team</li>
            </ol>
          </nav>
          <h1 className="mt-4 text-4xl md:text-5xl font-bold text-white">Meet the Team behind your smile.</h1>
          <p className="mt-4 text-lg text-white/90 max-w-2xl mx-auto">A close-knit group of dentists and clinical staff united by one belief: dentistry should feel calm, clear, and genuinely caring.</p>
        </div>
      </section>
      <DoctorsAccordion />
      <Appointment />
    </SiteLayout>
  );
}